import axios from "axios";

function factory(objectName) {
  return {
    name() {
      return objectName;
    },
    async create(data) {
      const response = await axios({
        data,
        method: "post",
        url: `/api/${objectName}`,
      });
      return response.data.result;
    },
    async get(id) {
      const response = await axios({
        method: "get",
        url: `/api/${objectName}/${id}`,
      });

      return response.data.result;
    },
    async list() {
      const response = await axios({
        method: "get",
        url: `/api/${objectName}`,
      });

      return response.data.result;
    },
    async listAdmin() {
      const response = await axios({
        method: "get",
        url: `/api/admin/${objectName}`,
      });

      return response.data.result;
    },
    async remove(id) {
      await axios({
        method: "delete",
        url: `/api/${objectName}/${id}`,
      });
    },
    async update(id, data) {
      delete data.updated;
      delete data.created;
      const response = await axios({
        data,
        method: "put",
        url: `/api/${objectName}/${id}`,
      });

      return response.data.result;
    },
  };
}

export default factory;
